import React, { useEffect, useRef, useState } from "react";
import tradeIcon from "../../../assets/img/Trade.svg";
import systemIcon from "../../../assets/img/systm.svg";
import subSystemIcon from "../../../assets/img/sub-systm.svg";
import { LazyLoadImage } from "react-lazy-load-image-component";
import ReactTooltip from "react-tooltip";
import imgProcess from "../../../assets/img/img-process.svg";
import noImage from "../../../assets/img/no-image-available.png";
import "../../../assets/css/image-management.css";
import "../../../assets/css/image-management-listing.css";
import { ImageBand } from "../../common/components/ImageComponents/ImageBand";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import Editor from "ckeditor5-custom-build/build/ckeditor";
import { removeAllTags } from "../../../config/utils";
import { sanitizeHtml } from "../../common/components/SafeHtml";

const editorConfiguration = {
    toolbar: [],
    removePlugins: ["Title", ""],
    alignment: {
        options: ["left", "right", "center", "justify"]
    },
    highlight: {
        options: [
            { model: "yellowMarker", class: "marker-yellow", title: "Yellow marker", color: "var(--ck-highlight-marker-yellow)", type: "marker" },
            { model: "greenMarker", class: "marker-green", title: "Green marker", color: "#32CD32", type: "marker" },
            { model: "pinkMarker", class: "marker-pink", title: "Pink marker", color: "#FF00FF", type: "marker" },
            { model: "blueMarker", class: "marker-blue", title: "Blue marker", color: "#0000FF", type: "marker" }
        ]
    },
    placeholder: "Type Here..."
};
const RecommendationPreview = ({
    selectedRecom,
    viewImageModal,
    imageList,
    getAllImageList,
    onPreviewCancel,
    deleteImage,
    updateImage,
    showMoreFilter = false,
    isSurveyAsset = false,
    hasCaptionEdit = true,
    isMobileRecommendation = false,
    hasQAQCComment = false,
    toggleCommentModal,
    outerDivClassName = ""
}) => {
    const [imageLoaded, setImageLoaded] = useState(false);
    const [selectedImage, setSelectedImage] = useState(imageList?.[0] || {});
    const zoomInRef = useRef(null);
    const zoomOutRef = useRef(null);
    const resetRef = useRef(null);
    const viewImageHandler = useRef(null);
    const [showAdditionalButtons, setShowAdditionalButtons] = useState(false);

    useEffect(() => {
        const images = imageList?.images ?? [];
        setSelectedImage(prev => images.find(item => item?.id === prev?.id) || images[0]);
    }, [imageList]);
    useEffect(() => {
        if (selectedImage?.master_image?.s3_image_key || selectedImage?.s3_image_key) {
            setImageLoaded(false);
            const img = new Image();
            img.src = !isSurveyAsset ? selectedImage.master_image.s3_image_key : selectedImage?.s3_image_key;
            img.onload = () => setImageLoaded(true);
        }
    }, [selectedImage]);

    const handleEyeClick = () => {
        if (viewImageHandler.current) {
            viewImageHandler.current();
        }
    };

    return (
        <div className={`image-manage recom-image-preview col-md-4 ${showMoreFilter ? "recom-pane-view" : ""}`}>
            <div className="cnt-sec">
                <div className={`preveiew col-md-12  ${outerDivClassName ?? ""}`}>
                    <div className="btn-main-outr caption-area d-flex justify-content-between align-items-center">
                        <div className="text-label text-area">
                            <label
                                className={`${hasQAQCComment ? "pane-view-label" : ""}`}
                                data-for={selectedRecom?.id}
                                style={{ cursor: "pointer", textTransform: "none" }}
                                data-tip={selectedRecom?.description && selectedRecom?.description}
                            >
                                <span>
                                    {isSurveyAsset
                                        ? isMobileRecommendation
                                            ? selectedRecom?.dynamic_fields?.description?.value || "-"
                                            : selectedRecom?.code || "-"
                                        : selectedRecom?.description || "-"}
                                </span>
                            </label>
                        </div>
                        {hasQAQCComment && (
                            <button className="issue-new-btn mr-4" onClick={() => toggleCommentModal(selectedRecom)}>
                                CBRE Review QC Comment
                            </button>
                        )}
                        <div
                            class="img-close"
                            onClick={() => {
                                setSelectedImage({});
                                onPreviewCancel();
                            }}
                        >
                            <img src="/img/close.svg" alt="" />
                        </div>
                    </div>
                    <div className="img-view cursor-hand">
                        {imageLoaded && selectedImage ? (
                            <div class="col-md-12 back-set">
                                <div className="details-img-block details-img-new col-md-12">
                                    <ImageBand
                                        basicDetails={{ images: selectedImage.id }}
                                        deleteImage={deleteImage}
                                        getAllImagesResponse={imageList}
                                        hasEdit={!isSurveyAsset}
                                        refreshImageList={() => getAllImageList(selectedRecom?.id, { limit: 100, offset: 1 })}
                                        isImagePreview={true}
                                        updateImage={updateImage}
                                        onZoomIn={zoomInFunc => (zoomInRef.current = zoomInFunc)}
                                        onZoomOut={zoomOutFunc => (zoomOutRef.current = zoomOutFunc)}
                                        onReset={resetFunc => (resetRef.current = resetFunc)}
                                        onViewImage={handler => {
                                            viewImageHandler.current = handler;
                                        }}
                                        isZoom={value => setShowAdditionalButtons(value)}
                                        isSurveyAssetView={isSurveyAsset}
                                        hasCaptionEdit={hasCaptionEdit}
                                    />
                                </div>
                            </div>
                        ) : (
                            <div className="image-preview">
                                <div class="img-process-otr">
                                    {!imageLoaded && imageList?.images?.length ? (
                                        <>
                                            <img src={imgProcess} />
                                            <h3>Processing...</h3>
                                        </>
                                    ) : (
                                        <img src={noImage} alt="" />
                                    )}
                                </div>
                            </div>
                        )}
                        {imageLoaded && selectedImage && (
                            <div className="md-grp-btn">
                                <button onClick={handleEyeClick}>
                                    <i class="far fa-eye"></i>
                                </button>
                                <button
                                    onClick={e => {
                                        zoomInRef?.current && zoomInRef?.current(e);
                                    }}
                                >
                                    <img src="/img/zoom-in.svg" alt="Zoom In" />
                                </button>
                                <button
                                    onClick={e => {
                                        zoomOutRef?.current && zoomOutRef?.current(e);
                                    }}
                                >
                                    <img src="/img/zoom-out.svg" alt="Zoom Out" />
                                </button>
                                <button
                                    className={`${!showAdditionalButtons ? "cursor-disabled" : "hand-cursor"}`}
                                    onClick={e => resetRef?.current && resetRef?.current(e)}
                                    disabled={!showAdditionalButtons}
                                >
                                    <i class="fas fa-sync image-icons"></i>
                                </button>
                            </div>
                        )}
                    </div>

                    {/* <div className="table-area">
                        <table className="table table-borderd">
                            <tbody>
                                <tr>
                                    <td>
                                        <div className="table-cnt">
                                            <div className="icons">
                                                <img src={tradeIcon} />
                                            </div>
                                            <div className="text-area">
                                                <h4>Trade</h4>
                                                <h3 data-for={selectedRecom?.id} data-tip={selectedRecom?.trade || ""}>
                                                    {selectedRecom?.trade}
                                                </h3>
                                            </div>
                                        </div>
                                    </td>
                                    <td>
                                        <div className="table-cnt">
                                            <div className="icons">
                                                <img src={systemIcon} />
                                            </div>
                                            <div className="text-area">
                                                <h4>System</h4>
                                                <h3 data-for={selectedRecom?.id} data-tip={selectedRecom?.system || ""}>
                                                    {selectedRecom?.system}
                                                </h3>
                                            </div>
                                        </div>
                                    </td>
                                    <td>
                                        <div className="table-cnt">
                                            <div className="icons">
                                                <img src={subSystemIcon} />
                                            </div>
                                            <div className="text-area">
                                                <h4>Sub-System</h4>
                                                <h3 data-for={selectedRecom?.id} data-tip={selectedRecom?.sub_system || ""}>
                                                    {selectedRecom?.sub_system}
                                                </h3>
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div> */}
                    <div className={`text-area recom-narative ${isSurveyAsset ? " wrapper-outer-side " : ""}`}>
                        {!isSurveyAsset ? (
                            <>
                                <h4>Recommendation Narrative</h4>
                                <CKEditor
                                    config={{ ...editorConfiguration, toolBar: [] }}
                                    editor={Editor}
                                    onReady={editor => {
                                        editor?.setData(selectedRecom?.note_html ? selectedRecom?.note_html : "");
                                        editor.enableReadOnlyMode("my-feature-id");
                                    }}
                                    data={selectedRecom?.note_html || ""}
                                />
                            </>
                        ) : isMobileRecommendation ? (
                            <>
                                <div className="wrap-txt-side col-md-6 p-0">
                                    <h4>Recommendation</h4>
                                    <span
                                        data-for={selectedRecom?.id}
                                        data-tip={
                                            selectedRecom?.dynamic_fields?.["description"]?.value &&
                                            selectedRecom?.dynamic_fields?.["description"]?.value?.length > 15
                                                ? selectedRecom?.dynamic_fields?.["description"]?.value
                                                : ""
                                        }
                                    >
                                        {selectedRecom?.dynamic_fields?.["description"]?.value
                                            ? selectedRecom?.dynamic_fields?.["description"]?.value?.length > 15
                                                ? selectedRecom?.dynamic_fields?.["description"]?.value.substring(0, 15) + "..."
                                                : selectedRecom?.dynamic_fields?.["description"]?.value
                                            : "-"}
                                    </span>
                                </div>

                                <div className="wrap-txt-side col-md-6">
                                    <h4>Building</h4>
                                    <span
                                        data-for={selectedRecom?.id}
                                        data-tip={
                                            selectedRecom?.dynamic_fields?.["building_id"]?.value &&
                                            selectedRecom?.dynamic_fields?.["building_id"]?.value?.length > 15
                                                ? selectedRecom?.dynamic_fields?.["building_id"]?.value
                                                : ""
                                        }
                                    >
                                        {selectedRecom?.dynamic_fields?.["building_id"]?.value
                                            ? selectedRecom?.dynamic_fields?.["building_id"]?.value?.length > 15
                                                ? selectedRecom?.dynamic_fields?.["building_id"]?.value.substring(0, 15) + "..."
                                                : selectedRecom?.dynamic_fields?.["building_id"]?.value
                                            : "-"}
                                    </span>
                                </div>
                                <div className="wrap-txt-side col-md-12 p-0">
                                    <h4>Recommendation Narrative</h4>
                                    <span
                                        data-for={selectedRecom?.id}
                                        data-tip={
                                            selectedRecom?.dynamic_fields?.["notes"]?.value &&
                                            selectedRecom?.dynamic_fields?.["notes"]?.value?.length > 45
                                                ? selectedRecom?.dynamic_fields?.["notes"]?.value
                                                : ""
                                        }
                                    >
                                        {selectedRecom?.dynamic_fields?.["notes"]?.value
                                            ? selectedRecom?.dynamic_fields?.["notes"]?.value?.length > 45
                                                ? removeAllTags(selectedRecom?.dynamic_fields?.["notes"]?.value).substring(0, 45) + "..."
                                                : removeAllTags(selectedRecom?.dynamic_fields?.["notes"]?.value)
                                            : "-"}
                                    </span>
                                </div>
                            </>
                        ) : (
                            <>
                                <div className="wrap-txt-side col-md-6 p-0">
                                    <h4>Asset Name</h4>
                                    <span
                                        data-for={selectedRecom?.id}
                                        data-tip={
                                            selectedRecom?.dynamic_fields?.["assets.asset_name"]?.value &&
                                            selectedRecom?.dynamic_fields?.["assets.asset_name"]?.value?.length > 15
                                                ? selectedRecom?.dynamic_fields?.["assets.asset_name"]?.value
                                                : ""
                                        }
                                    >
                                        {selectedRecom?.dynamic_fields?.["assets.asset_name"]?.value
                                            ? selectedRecom?.dynamic_fields?.["assets.asset_name"]?.value?.length > 15
                                                ? selectedRecom?.dynamic_fields?.["assets.asset_name"]?.value.substring(0, 15) + "..."
                                                : selectedRecom?.dynamic_fields?.["assets.asset_name"]?.value
                                            : "-"}
                                    </span>
                                </div>

                                <div className="wrap-txt-side col-md-6">
                                    <h4>Asset Tag</h4>
                                    <span
                                        data-for={selectedRecom?.id}
                                        data-tip={
                                            selectedRecom?.dynamic_fields?.["assets.asset_tag"]?.value &&
                                            selectedRecom?.dynamic_fields?.["assets.asset_tag"]?.value?.length > 15
                                                ? selectedRecom?.dynamic_fields?.["assets.asset_tag"]?.value
                                                : ""
                                        }
                                    >
                                        {selectedRecom?.dynamic_fields?.["assets.asset_tag"]?.value
                                            ? selectedRecom?.dynamic_fields?.["assets.asset_tag"]?.value?.length > 15
                                                ? selectedRecom?.dynamic_fields?.["assets.asset_tag"]?.value.substring(0, 15) + "..."
                                                : selectedRecom?.dynamic_fields?.["assets.asset_tag"]?.value
                                            : "-"}
                                    </span>
                                </div>
                                <div className="wrap-txt-side col-md-6 p-0">
                                    <h4>Manufacturer</h4>
                                    <span
                                        data-for={selectedRecom?.id}
                                        data-tip={
                                            selectedRecom?.dynamic_fields?.["assets.manufacturer"]?.value &&
                                            selectedRecom?.dynamic_fields?.["assets.manufacturer"]?.value?.length > 15
                                                ? selectedRecom?.dynamic_fields?.["assets.manufacturer"]?.value
                                                : ""
                                        }
                                    >
                                        {selectedRecom?.dynamic_fields?.["assets.manufacturer"]?.value
                                            ? selectedRecom?.dynamic_fields?.["assets.manufacturer"]?.value?.length > 15
                                                ? selectedRecom?.dynamic_fields?.["assets.manufacturer"]?.value.substring(0, 15) + "..."
                                                : selectedRecom?.dynamic_fields?.["assets.manufacturer"]?.value
                                            : "-"}
                                    </span>
                                </div>
                                <div className="wrap-txt-side col-md-6">
                                    <h4>Serial Number</h4>
                                    <span
                                        data-for={selectedRecom?.id}
                                        data-tip={
                                            selectedRecom?.dynamic_fields?.["assets.serial_number"]?.value &&
                                            selectedRecom?.dynamic_fields?.["assets.serial_number"]?.value?.length > 15
                                                ? selectedRecom?.dynamic_fields?.["assets.serial_number"]?.value
                                                : ""
                                        }
                                    >
                                        {selectedRecom?.dynamic_fields?.["assets.serial_number"]?.value
                                            ? selectedRecom?.dynamic_fields?.["assets.serial_number"]?.value?.length > 15
                                                ? selectedRecom?.dynamic_fields?.["assets.serial_number"]?.value.substring(0, 15) + "..."
                                                : selectedRecom?.dynamic_fields?.["assets.serial_number"]?.value
                                            : "-"}
                                    </span>
                                </div>
                                <div className="wrap-txt-side col-md-6 p-0">
                                    <h4>Model Number</h4>
                                    <span
                                        data-for={selectedRecom?.id}
                                        data-tip={
                                            selectedRecom?.dynamic_fields?.["assets.model_number"]?.value &&
                                            selectedRecom?.dynamic_fields?.["assets.model_number"]?.value?.length > 15
                                                ? selectedRecom?.dynamic_fields?.["assets.model_number"]?.value
                                                : ""
                                        }
                                    >
                                        {selectedRecom?.dynamic_fields?.["assets.model_number"]?.value
                                            ? selectedRecom?.dynamic_fields?.["assets.model_number"]?.value?.length > 15
                                                ? selectedRecom?.dynamic_fields?.["assets.model_number"]?.value.substring(0, 15) + "..."
                                                : selectedRecom?.dynamic_fields?.["assets.model_number"]?.value
                                            : "-"}
                                    </span>
                                </div>
                                <div className="wrap-txt-side col-md-6">
                                    <h4>Asset Condition</h4>
                                    <span
                                        data-for={selectedRecom?.id}
                                        data-tip={
                                            selectedRecom?.dynamic_fields?.["assets.client_asset_condition_id"]?.value &&
                                            selectedRecom?.dynamic_fields?.["assets.client_asset_condition_id"]?.value?.length > 15
                                                ? selectedRecom?.dynamic_fields?.["assets.client_asset_condition_id"]?.value
                                                : ""
                                        }
                                    >
                                        {selectedRecom?.dynamic_fields?.["assets.client_asset_condition_id"]?.value
                                            ? selectedRecom?.dynamic_fields?.["assets.client_asset_condition_id"]?.value?.length > 15
                                                ? selectedRecom?.dynamic_fields?.["assets.client_asset_condition_id"]?.value.substring(0, 15) + "..."
                                                : selectedRecom?.dynamic_fields?.["assets.client_asset_condition_id"]?.value
                                            : "-"}
                                    </span>
                                </div>
                                <div className="wrap-txt-side col-md-6 p-0">
                                    <h4>Current Age</h4>
                                    <span
                                        data-for={selectedRecom?.id}
                                        data-tip={
                                            selectedRecom?.dynamic_fields?.["assets.current_age"]?.value &&
                                            selectedRecom?.dynamic_fields?.["assets.current_age"]?.value?.length > 15
                                                ? selectedRecom?.dynamic_fields?.["assets.current_age"]?.value
                                                : ""
                                        }
                                    >
                                        {selectedRecom?.dynamic_fields?.["assets.current_age"]?.value
                                            ? selectedRecom?.dynamic_fields?.["assets.current_age"]?.value?.length > 15
                                                ? selectedRecom?.dynamic_fields?.["assets.current_age"]?.value.substring(0, 15) + "..."
                                                : selectedRecom?.dynamic_fields?.["assets.current_age"]?.value
                                            : "-"}
                                    </span>
                                </div>
                                <div className="wrap-txt-side col-md-6">
                                    <h4>Parent Global</h4>
                                    <span
                                        data-for={selectedRecom?.id}
                                        data-tip={
                                            selectedRecom?.dynamic_fields?.["assets.parent_global_id"]?.value &&
                                            selectedRecom?.dynamic_fields?.["assets.parent_global_id"]?.value?.length > 15
                                                ? selectedRecom?.dynamic_fields?.["assets.parent_global_id"]?.value
                                                : ""
                                        }
                                    >
                                        {selectedRecom?.dynamic_fields?.["assets.parent_global_id"]?.value
                                            ? selectedRecom?.dynamic_fields?.["assets.parent_global_id"]?.value?.length > 15
                                                ? selectedRecom?.dynamic_fields?.["assets.parent_global_id"]?.value.substring(0, 15) + "..."
                                                : selectedRecom?.dynamic_fields?.["assets.parent_global_id"]?.value
                                            : "-"}
                                    </span>
                                </div>
                                <div className="wrap-txt-side col-md-6 p-0">
                                    <h4>Legacy Asset Tag ID</h4>
                                    <span
                                        data-for={selectedRecom?.id}
                                        data-tip={
                                            selectedRecom?.dynamic_fields?.["legacy_asset_tag_id"]?.value &&
                                            selectedRecom?.dynamic_fields?.["legacy_asset_tag_id"]?.value?.length > 15
                                                ? selectedRecom?.dynamic_fields?.["legacy_asset_tag_id"]?.value
                                                : ""
                                        }
                                    >
                                        {selectedRecom?.dynamic_fields?.["legacy_asset_tag_id"]?.value
                                            ? selectedRecom?.dynamic_fields?.["legacy_asset_tag_id"]?.value?.length > 15
                                                ? selectedRecom?.dynamic_fields?.["legacy_asset_tag_id"]?.value.substring(0, 15) + "..."
                                                : selectedRecom?.dynamic_fields?.["legacy_asset_tag_id"]?.value
                                            : "-"}
                                    </span>
                                </div>
                                <div className="wrap-txt-side col-md-6">
                                    <h4>Uniformat Level 6</h4>
                                    <span
                                        data-for={selectedRecom?.id}
                                        data-tip={
                                            selectedRecom?.dynamic_fields?.["assets.uniformat_level_6_id"]?.value &&
                                            selectedRecom?.dynamic_fields?.["assets.uniformat_level_6_id"]?.value?.length > 58
                                                ? selectedRecom?.dynamic_fields?.["assets.uniformat_level_6_id"]?.value
                                                : ""
                                        }
                                    >
                                        {selectedRecom?.dynamic_fields?.["assets.uniformat_level_6_id"]?.value
                                            ? selectedRecom?.dynamic_fields?.["assets.uniformat_level_6_id"]?.value?.length > 58
                                                ? selectedRecom?.dynamic_fields?.["assets.uniformat_level_6_id"]?.value.substring(0, 58) + "..."
                                                : selectedRecom?.dynamic_fields?.["assets.uniformat_level_6_id"]?.value
                                            : "-"}
                                    </span>
                                </div>
                            </>
                        )}
                    </div>

                    <ReactTooltip
                        id={selectedRecom?.id}
                        effect="solid"
                        backgroundColor="#1383D9"
                        getContent={dataTip => (dataTip ? sanitizeHtml(dataTip) : "")}
                        html={true}
                        multiline={true}
                    />
                </div>
            </div>
        </div>
    );
};

export default RecommendationPreview;
